import Box from '@mui/material/Box'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import SidebarPendingOrderDataView from './SidebarPendingOrderDataView'
import SidebarInitActionsSlTp, { SidebarBasicTitle } from './SidebarPendingOrderSlTp'
import {getSoIdNumber, updateSlTp, updateSlTpOpenTrade} from '../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import { updateDataSizeTradeLot } from '../../../../../store/redusers/assets/actions'
import {
	selectAssetTailDigits,
	selectAssetTitle,
	selectLatestRatesBidAsk,
	selectPipDecimalPlaces,
	selectSelectedAsset
} from '../../../../../store/redusers/assets/selectors'
import { selectAccessToken } from '../../../../../store/redusers/auth/selectors'
import {
	setLotAction,
	setNewOpenTrade,
	setNewPendingOrder,
	setOrderTradeSellBuy
} from '../../../../../store/redusers/orders/actions'
import {
	selectExecutionEntryRate,
	selectLotCountData,
	selectNewTradeType,
	selectPipValue,
	selectStopLoss,
	selectTakeProfit
} from '../../../../../store/redusers/orders/selectors'
import {selectTailDigitOfCurrency} from '../../../../../store/redusers/positions/selectors'
import { selectMaxLotCount, selectMinLotCount, selectUserId } from '../../../../../store/redusers/user/selectors'
import AppButton from '../../../../AppButton'
import AppNumberField from '../../../../AppNumberField'
import AppTooltip from '../../../../AppTooltip'
import AssetsButtons from '../../../../Dashboard/Assets/AssetsItem/AssetsButtons'
import HighChart from '../Highchart/Highchart'

function SidebarPendingOrder({ isOpenTradeTab }) {
	const { dispatch, alert, t } = useDefaultComponentTools(true)
	const lotCountData = useSelector(selectLotCountData)
	const [ type, setType ] = useState('')
	const [ isSuccessCreate, setIsSuccessCreate ] = useState(false)
	const asset = useSelector(selectSelectedAsset) || ''
	const userId = useSelector(selectUserId)
	const stopLoss = useSelector(selectStopLoss)
	const takeProfit = useSelector(selectTakeProfit)
	const executionEntryRate = useSelector(selectExecutionEntryRate)
	const isSelectedType = type === ''
	const soId = getSoIdNumber(asset.assetSoId)
	const typePendingTrade = type === 'buy' ? 'buy-limit' : 'sell-stop'
	const [takeProfitAmount, setTakeProfitAmount] = useState('')
	const [stopLossAmount, setStopLossAmount] = useState('')
	const cookies = new Cookies()
	const orderFormData = `${
		'&assetId=' + soId
		+'&executionEntryRate=' + executionEntryRate
		+'&leverage=' + (lotCountData[soId] || 1)
		+'&stopLoss=' + stopLoss
		+'&stopLossAmount=' + stopLossAmount
		+'&takeProfit=' + takeProfit
		+'&takeProfitAmount=' + takeProfitAmount
		+'&type=' + typePendingTrade
		+'&userId=' + userId
	}`
	const assetTitle = useSelector(selectAssetTitle(asset.assetType, asset.assetSoId)) || ''
	const newTradeType = useSelector(selectNewTradeType)
	const typeAsset = soId > 4000 ? 'crypto' : 'forex'
	const accessToken = useSelector(selectAccessToken)
	const pipValue = useSelector(selectPipValue)
	const isAuthorized = useSelector(selectUserId)
	const pipDecimalPlaces = useSelector(selectPipDecimalPlaces(asset.assetType, asset.assetSoId))
	const tailDigits = useSelector(selectAssetTailDigits(asset.assetType, asset.assetSoId))
	const tailDigitOfCurrency = useSelector(selectTailDigitOfCurrency)
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk(asset.assetSoId))
	const minLotCount = useSelector(selectMinLotCount)
	const maxLotCount = useSelector(selectMaxLotCount)
	const bidRate = latestRatesBidAsk.bid
	const askRate = latestRatesBidAsk.ask
	const cookieAccessToken = cookies.get('oauth_access_token')
	useEffect(() => {
		setType(newTradeType)
	}, [newTradeType])

	const tradeFormData = `${
		'&trade[assetClass]=' + asset.assetType
		+ '&trade[assetName]=' + assetTitle
		+ '&trade[stopLoss]=' + stopLoss
		+ '&trade[takeProfit]=' + takeProfit
		+ '&trade[pipValueClient]=' + pipValue
		+ '&trade[position]=' + type
		+ '&trade[type]=' + typeAsset
		+ '&trade[assetId]=' + soId
		+ '&trade[amount]=1'
		+ '&isCurrency=0'
		+ '&trade[marginTrade]=1'
		+ '&trade[leverage]=' + Math.max(lotCountData[soId] || 1, 0.01)
		+ '&trade[userId]=' + userId
		+ '&trade[timestampClient]=' + dayjs().unix()
	}`

	const handleInputChange = (e, type, orderType) => {
		dispatch(setOrderTradeSellBuy(orderType))
		setType(orderType)
	}

	const onSetLot = (fieldName, fieldValue) => {
		dispatch(setLotAction({ [soId]: fieldValue }))
	}
	const refreshSlTp = (fncSlTP) => {
		fncSlTP('sl', '')
		fncSlTP('tp', '')
	}

	const handlePendingOrder = async (e) => {
		e.preventDefault()
		try {
			alert.info(t('Executing order')+'...', { loader: true, timeout: 0, title: 'Execute order' })
			let res
			dispatch(updateDataSizeTradeLot(true, cookieAccessToken || accessToken))
			isOpenTradeTab ? res = await dispatch(setNewOpenTrade(tradeFormData, accessToken, userId))
				: res = await dispatch(setNewPendingOrder(orderFormData, accessToken, userId, alert))
			if (res) {
				refreshSlTp(!isOpenTradeTab ? updateSlTpCreate : updateSlTpCreateOpen)
				alert.removeAll()
				setIsSuccessCreate(true)
				alert.success('The trade is opened')
			}
		}
		catch (e) {
			alert.removeAll()
			'message' in e && alert.error(e.message)
		}
	}
	function updateSlTpCreate(typeAmount, value){
		updateSlTp(
			+executionEntryRate,
			+pipValue,
			pipDecimalPlaces,
			type,
			typeAmount,
			+value,
			tailDigitOfCurrency,
			setStopLossAmount,
			setTakeProfitAmount,
			tailDigits)
	}
	function updateSlTpCreateOpen(typeAmount, value){
		updateSlTpOpenTrade(
			+value,
			type === 'buy' ? +askRate : +bidRate, //myTrade
			+pipValue, //myTrade
			pipDecimalPlaces, //myTrade
			typeAmount,
			type, //myTrade.position,
			tailDigitOfCurrency,
			setStopLossAmount,
			setTakeProfitAmount)
	}

	useEffect(() => {
		if(isOpenTradeTab) {
			if (takeProfit) updateSlTpCreateOpen('tp', takeProfit)
			if (stopLoss) updateSlTpCreateOpen('sl', stopLoss)
		} else {
			if (takeProfit) updateSlTpCreate('tp', takeProfit)
			if (stopLoss) updateSlTpCreate('sl', stopLoss)
		}
	},[pipValue, executionEntryRate, isOpenTradeTab])

	return (<Box>
		{!isAuthorized ?
			null :
			<Box sx={{mb: '15px'}}>
				<AssetsButtons
					assetSoId={asset.assetSoId}
					clickAsset={handleInputChange}
					customSx={{width: '100%'}}
					active={type}
				/>
			</Box>
		}
		<Box sx={{ display: 'flex' }}>
			<SidebarBasicTitle sx={{ mb: 1, mr: 0.5 }}>
				{t('Lots')}
			</SidebarBasicTitle>
			<AppTooltip
				sxElement={{position: 'absolute', top: '-5px'}}
				title={`Lot size is ${minLotCount + ' - ' + maxLotCount}`} icon='info' placement='top-start'/>
		</Box>
		<AppNumberField
			value={+lotCountData[soId] || 1}
			onGetValue={onSetLot}
			name='lots'
			minLotCount={+minLotCount}
			maxLotCount={+maxLotCount}
		/>
		{asset && <SidebarPendingOrderDataView lots={lotCountData[soId] || 1} asset={asset} />}
		{isAuthorized && !isSelectedType ?
			<SidebarInitActionsSlTp
				isOpenTradeTab={isOpenTradeTab}
				stopLossAmount={stopLossAmount}
				takeProfitAmount={takeProfitAmount}
				updateSlTp={!isOpenTradeTab ? updateSlTpCreate : updateSlTpCreateOpen}
				myId={'new'+soId}
				position={type}
				assetId={soId}
				isSuccessOpenTrade={isSuccessCreate}
				setIsSuccessCreate={setIsSuccessCreate}
			/> :
			null
		}
		{isAuthorized && !isSelectedType && !isOpenTradeTab ?
			<Box sx={{mb:'24px'}}><HighChart asset={asset}/></Box> : null}
		{isAuthorized && !isSelectedType ? <AppButton onClick={handlePendingOrder} type='submit' title='Order'/> : null}
	</Box>)
}

SidebarPendingOrder.propTypes = {
	isOpenTradeTab: PropTypes.bool
}

export default SidebarPendingOrder
